/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsAirplaneTopView: {
  name: 'airplane-top-view';
  data: string;
} = {
  name: 'airplane-top-view',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.293 2.293a1 1 0 0 1 1.414 0l2 2A1 1 0 0 1 15 5v2.667l5.8 7.733a1 1 0 0 1 .2.6v4a1 1 0 0 1-1.64.768L15 17.135V21a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-3.865l-4.36 3.633A1 1 0 0 1 3 20v-4a1 1 0 0 1 .2-.6L9 7.667V5a1 1 0 0 1 .293-.707l2-2ZM13 14.993V20h-2V5.414l1-1 1 1v9.578Zm2-.461 4 3.333v-1.532L15 11v3.532Zm-6 0V11l-4 5.333v1.532l4-3.333Z" fill="currentColor"/></svg>`,
};
